export default "__VITE_ASSET__YkehGiIH__"